/**
 * @component
 * @visibleName formatPhone
 */
export default function formatPhone(numberValue: number, { locale = 'fr' }: { locale?: string } = {}) {
  const resolvedLocale = locale.substring(0, 2);
  const formats = [
    { pos: 10, value: (resolvedLocale === 'fr') ? ' ' : '-' },
    { pos: 7, value: (resolvedLocale === 'fr') ? ' ' : '-' },
    { pos: 4, value: '-' },
  ];
  let returnValue = numberValue.toString();
  const { length } = returnValue;

  if (!(length === 7 || length === 10 || length === 11)) return returnValue;

  formats.forEach((f) => {
    const v = returnValue.length - f.pos;
    if (v >= 1) { returnValue = returnValue.slice(0, v) + f.value + returnValue.slice(v); }
  });

  return returnValue;
}
